import api from './api';

const notificationService = {
  /**
   * Busca todas as notificações do usuário
   * @param unread Se true, busca apenas não lidas
   */
  getAll: async (unread?: boolean): Promise<any> => {
    try {
      const response = await api.get('/notifications', {
        params: unread ? { unread: true } : {},
      });

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar notificações:', error);
      throw error;
    }
  },

  /**
   * Marca uma notificação como lida
   * @param id ID da notificação
   */
  markAsRead: async (id: number): Promise<boolean> => {
    try {
      const response = await api.post(`/notifications/${id}/read`);
      return response.data.success;
    } catch (error) {
      console.error(`Erro ao marcar notificação ${id} como lida:`, error);
      throw error;
    }
  },

  /**
   * Marca todas as notificações como lidas
   */
  markAllAsRead: async (): Promise<boolean> => {
    try {
      const response = await api.post('/notifications/read-all');
      return response.data.success;
    } catch (error) {
      console.error('Erro ao marcar todas notificações como lidas:', error);
      throw error;
    }
  },
};

export default notificationService;
